<template>
  <div @click="showModal()">
    <button class="btn btn-primary bgprimarycolor" data-title="View SOW(s)">
      SOW(s)
    </button>
    <b-modal
      ref="sowdetailsmodal"
      size="lg"
      centered
      scrollable
      hide-footer
      :title="`SOW Details for ${projectName}`"
    >
      <div v-if="sow_details.length > 0">
        <div>
          <label>Title : {{ sow_details[0].Title }}</label>
        </div>
        <div>
          <label for="">Description : {{ sow_details[0].Description }}</label>
        </div>
        <div v-for="p in sow_details[0].Data.PlaceHolders" :key="p.Name">
          <label
            >{{ p.Name }} :
            <span class="text-black">{{ p.Value }} </span></label
          >
        </div>
      </div>
      <div v-else>
        <h3>SOW Details not found</h3>
      </div>
    </b-modal>
  </div>
</template>

<script>
import projectService from "@/services/projectService";
import { EventBus } from "@/EventBus";

export default {
  name: "SOWDetails",
  props: ["projectName"],
  methods: {
    showModal() {
      EventBus.$emit("toast", {
        title: "SOW Details",
        message: "Fetching SOW Details",
        variant: "success",
      });
      projectService
        .getSOWS(this.projectName)
        .then((response) => {
          this.sow_details = response.data.data;
          this.$refs["sowdetailsmodal"].show();
        })
        .catch((err) => {});
    },
  },
  data() {
    return {
      sow_details: [],
    };
  },
};
</script>